const replaceSpaces = (str: string): string => {
  return str.trim().replace(/\s/g, '_').toLowerCase();
};

const formatEventSource = (eventSource: string): string => {
  if (eventSource) {
    return eventSource.replace(/-/g, '_').toLowerCase();
  }

  return 'signup';
};

const formatAnalyticsValue = (property: string, value: string): string => {
  switch (property) {
    case 'event_source':
      return formatEventSource(value);
    default:
      return replaceSpaces(value);
  }
};

export const formatGA4EventProps = (props: { [key: string]: string }) => {
  return Object.keys(props).reduce((acc, key: string) => {
    const eventProperty = props[key];

    acc[key] = formatAnalyticsValue(key, eventProperty);
    return acc;
  }, {});
};

export const getItemLocation = (str?: string) => {
  const rootDataPathElement = document.querySelector('[data-ga4-wt-page-path]');
  const rootDataPath = rootDataPathElement?.getAttribute(
    'data-ga4-wt-page-path',
  );

  const itemLocation = [rootDataPath, str].filter((v) => v).join('.');

  return itemLocation;
};

export const setDataPath = (itemLocation: string): Element => {
  const rootDataPathElement = document.querySelector('[data-ga4-wt-page-path]');
  rootDataPathElement?.setAttribute('data-path', itemLocation);

  return rootDataPathElement;
};

export const setWhiteTeamGA4Defaults = (product: string) => {
  window?.analytics?.setDefaults('semrush_team', 'white_team');
  window?.analytics?.setDefaults('semrush_product_name', product);
};
